import { creditEndPoint } from '../constants';

export default {
  creditBalance: `${creditEndPoint}/credit-balance`,
  getSubscribedLoan: `${creditEndPoint}/get-subscribed-loan`,
  kycStatus: `${creditEndPoint}/kyc/get-kyc-status`,
};
